export function createDispatchConsoleBffClient(transport) {
    return {
        /**
         * GET /health/live
         *
         * The contract declares no response schema for this operation, so the
         * result is `unknown` and the caller must narrow it. That is the
         * contract's gap, not the generator's.
         */
        getLiveness(options) {
            return transport.request({
                method: "GET",
                path: "/health/live",
                options,
            });
        },
        /**
         * GET /health/ready
         *
         * The contract declares no response schema for this operation, so the
         * result is `unknown` and the caller must narrow it. That is the
         * contract's gap, not the generator's.
         */
        getReadiness(options) {
            return transport.request({
                method: "GET",
                path: "/health/ready",
                options,
            });
        },
        /**
         * Report this service's identity and declared implementation status
         */
        getServiceInfo(options) {
            return transport.request({
                method: "GET",
                path: "/v1/service-info",
                options,
            });
        },
        /**
         * Everything the dispatch live map draws, in one read
         *
         * Requires scope: dispatch-console:read
         */
        getDispatchConsoleLiveMap(tenantId, options) {
            return transport.request({
                method: "GET",
                path: `/v1/tenants/${encodeURIComponent(tenantId)}/dispatch-console/live-map`,
                options,
            });
        },
        /**
         * The dispatch exceptions board as one urgency-ordered queue
         *
         * Requires scope: dispatch-console:read
         */
        getDispatchConsoleExceptions(tenantId, options) {
            return transport.request({
                method: "GET",
                path: `/v1/tenants/${encodeURIComponent(tenantId)}/dispatch-console/exceptions`,
                options,
            });
        },
        /**
         * The deliveries in flight, each with the courier carrying it
         *
         * Requires scope: dispatch-console:read
         */
        getDispatchConsoleDeliveries(tenantId, options) {
            return transport.request({
                method: "GET",
                path: `/v1/tenants/${encodeURIComponent(tenantId)}/dispatch-console/deliveries`,
                options,
            });
        },
    };
}
//# sourceMappingURL=dispatch-console-bff.js.map